import { checkNumber, stringCount } from './index';
import { appConfig } from '../settings';

export const formatByte = (input: null | undefined | number | string): string => {
    if (input === null || input === undefined) {
        return '0';
    }
    const num = typeof input === 'number' ? input : Number(input.replace(/\s+/g, ''));
    if (!Number.isFinite(num) || num <= 0) {
        return '0';
    }
    return Math.floor(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const byteConverter = (amount: number, formatId: number): number => {
    // ToDo: need think about what decimals 1000/1024 use for convertion
    switch (appConfig.bytesTypes[formatId]?.name) {
        case 'B':
            return amount;
        case 'KB':
            return amount * 1000;
        case 'MB':
            return amount * 1000000;
        case 'GB':
            return amount * 1000000000;
        default:
            return amount;
    }
};

type IRateLabelName = 'bytes' | 'long1' | 'long2' | 'sec' | 'short' | 'si' | 'symbol';

type IRateLabels = {
    [key in IRateLabelName]: Array<string>;
};

export const rateLabels: IRateLabels = {
    bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    long1: [
        '',
        'thousand',
        'million',
        'billion',
        'trillion',
        'quadrillion',
        'quintillion',
        'sextillion',
        'septillion',
        'octillion',
        'nonillion',
    ],
    long2: [
        '',
        'thousand',
        'thousand million',
        'billion',
        'thousand billion',
        'trillion',
        'thousand trillion',
        'quadrillion',
        'thousand quadrillion',
        'quintillion',
    ],
    short: ['', 'K.', 'mln.', 'bln.', 'trln.', 'qudln.', 'qutln.', 'sxtln.', 'septln.', 'octln.', 'nonln.'],
    sec: ['sec', 'min', 'hour'],
    si: ['', 'kilo-', 'mega-', 'giga-', 'tera-', 'peta-', 'exa-', 'zetta-', 'yotta-'],
    symbol: [
        '',
        'thousand',
        'million',
        'billion',
        'trillion',
        'quadrillion',
        'quintillion',
        'sextillion',
        'septillion',
    ],
};

// export const byteMb = (byte: any, divider = 1024, decimal = 0): string => {
//     if (divider === 0) {
//         console.error(`divider === 0`);
//         return '0';
//     } else {
//         let newValue = checkNumber(byte) / divider / divider;
//         newValue = Math.round(newValue * 10 ** decimal) / 10 ** decimal;
//         return `${newValue}`;
//     }
// };
// export const byteMb1000 = (byte: any, decimal = 3): string => {
//     return byteMb(byte, 1000, decimal);
// };
export const byteSignificantDigits = (byte: any, divider = 1000, decimal = 0): string => {
    return range(byte, divider, decimal, rateLabels.bytes);
};
// export const byteRange1000 = (byte: any, decimal = 3): string => {
//     return byteRange(byte, 1000, decimal);
// };
export const range1000 = (byte: any, decimal = 3, labels?: string[]): string => {
    return range(byte, 1000, decimal, labels);
};

// export const kbRange = (byte: any, divider = 1024, decimal = 0): string => {
//     const kbs = [...rateLabels.bytes].slice(1);
//     return range(byte, divider, decimal, kbs);
// };

export const moneyRange = (cost: any, label = rateLabels.short.slice(0, 5)): string => {
    return range(cost, 1000, 0, label);
};

export const smsRange = (value: any): string => {
    return `${range(value, 1000, 0, rateLabels.symbol)} sms`;
};
export const byteAccuredConvertion = (byte: number, decimals = 3): string | null => {
    if (!byte) return null;
    const dm = decimals < 0 ? 0 : decimals;
    const labelIndex = Math.floor(Math.log(byte) / Math.log(1000));

    return `${parseFloat((byte / Math.pow(1000, labelIndex)).toFixed(dm))} ${rateLabels.bytes[labelIndex]}`;
};

export function formatBytesToRange(bytes = 0, k = 1000, decimals = 0, range = 3): string {
    if (bytes === 0) return '0 B';

    const dm = decimals < 0 ? 0 : decimals;

    let i = Math.floor(Math.log(bytes) / Math.log(k));

    if (i > range) {
        i = range;
    }

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + rateLabels.bytes[i];
}

export function formatBytesIntegerOnly(byte: number | null | undefined, divider = 1000): string {
    if (!byte || byte <= 0) {
        return `0 ${rateLabels.bytes[0]}`;
    }

    let size = byte;
    let index = 0;

    while (size % divider === 0 && size >= divider && index < rateLabels.bytes.length - 1) {
        size = size / divider;
        index++;
    }

    return `${size} ${rateLabels.bytes[index]}`;
}

export const range = (value: any, divider = 1000, decimal = 0, labels = rateLabels.short): string => {
    let prefix = '';
    let newValue = checkNumber(value);
    if (newValue < 0) {
        prefix = '-';
        newValue = newValue * -1;
    }
    let range = 0;
    while (newValue / divider > 1 && range < labels.length - 1) {
        newValue = newValue / divider;
        range++;
    }
    newValue = Math.round(newValue * 10 ** decimal) / 10 ** decimal;
    const label = range > labels.length - 1 ? labels[labels.length - 1] : labels[range];
    return `${prefix}${stringCount(newValue, decimal)} ${label}`;
};

export const minutesRange = (seconds: any = 0): string => {
    const checkedSeconds = checkNumber(seconds);

    if (checkedSeconds < 60) {
        return `${seconds} sec`;
    }

    return `${range(checkNumber(seconds) / 60, 1000, 0, rateLabels.short)} min`;
};
